import {
  BadgeCheckSolidIcon,
  DownLongRegularIcon,
  PaperPlaneRegularIcon,
  PrintRegularIcon,
  WhatsAppBrandIcon,
} from "@elixir/icons";
import { useReceiptStore } from "@elixir/stores";
import { Modal, notification } from "antd";
import {
  PdfRenderer,
  PrimaryButton,
  ReceiptActionItem,
  SecondaryButton,
} from "ui";
import {
  closeReceiptPopupEvent,
  createNewReceipt,
  editReceipt,
} from "../../utils/receipt";
import { sendBusinessReceiptWAMessage } from "apis";
import { ERROR_CODE, RECEIPT_FLOW_STATES, RECEIPT_TYPE } from "@elixir/types";

export default function ServerMadeReceiptsFlowUI() {
  const receipt = useReceiptStore((state) => state.receipt);
  const receiptState = useReceiptStore((state) => state.receiptState);
  const closeReceiptPopup = useReceiptStore(
    (state) => state.setCloseReceiptPopup
  );

  const sendViaOwnWhatsApp = () => {
    try {
      const wpString = `Here is the payment receipt for your consultation : ${receipt?.receipt_url}`;
      window.open(
        `https://api.whatsapp.com/send?phone=${receipt?.mobile}&text=${wpString}`,
        "_blank"
      );
    } catch (e) {
      console.error(e);
    }
  };

  return (
    <Modal
      width={840}
      centered
      open={receiptState === RECEIPT_FLOW_STATES.VIEW_SINGLE_RECEIPT}
      destroyOnClose
      bodyStyle={{ padding: 0 }}
      style={{ borderRadius: 8 }}
      className="modal-rounded-8"
      closeIcon={<></>}
      onCancel={() => {
        closeReceiptPopup();
        closeReceiptPopupEvent();
      }}
      footer={<ReceiptActionFooter />}
    >
      <div
        style={{ height: "75vh" }}
        className="dr-flex dr-justify-between dr-min-h-400 dr-p-16 dr-space-x-16"
      >
        <div className="dr-flex-1 dr-flex dr-flex-col dr-space-y-16">
          <div className="dr-flex dr-items-center dr-space-x-8">
            <div className="dr-flex dr-items-center dr-justify-center">
              <BadgeCheckSolidIcon className="dr-text-darwin-green-primary dr-w-24 dr-h-24" />
            </div>
            <p className="dr-text-13 dr-font-700 dr-text-darwin-neutral-1000">
              {receipt?.receipt_type === "DUE_PAYMENT"
                ? `Payment Note for ₹ `
                : `Receipt for ₹ `}
              {receipt?.net_amount?.toLocaleString("en-IN") || "0"} created
              successfully
            </p>
          </div>
          <div className="dr-flex dr-flex-col dr-space-y-2">
            <ReceiptActionItem
              icon={
                <PaperPlaneRegularIcon className="dr-text-darwin-primary-primary dr-w-16 dr-h-16" />
              }
              title="Send"
              subtext="Via SMS and Whatsapp"
              onClick={async () => {
                if (receipt) {
                  const { success, error_meta } =
                    await sendBusinessReceiptWAMessage({
                      receiptId: receipt.receipt_id!,
                    });

                  if (success) {
                    if (
                      error_meta &&
                      error_meta.code === ERROR_CODE.LOW_CREDITS
                    ) {
                      notification.success({
                        message: error_meta.message,
                        placement: "bottomRight",
                      });
                    } else {
                      notification.success({
                        message: "Receipt sent successfully on whatsapp",
                        placement: "bottomRight",
                      });
                    }
                  } else {
                    notification.error({
                      message: "Failed to Send Receipt",
                      placement: "bottomRight",
                    });
                  }
                }
              }}
            />
            <ReceiptActionItem
              icon={
                <PrintRegularIcon className="dr-text-darwin-primary-primary dr-w-16 dr-h-16" />
              }
              title="Print"
              subtext="View and print the receipt"
              onClick={() => {
                if (receipt?.receipt_url) {
                  window.open(receipt?.receipt_url, "_blank");
                }
              }}
            />
            <ReceiptActionItem
              icon={
                <DownLongRegularIcon className="dr-text-darwin-primary-primary dr-w-16 dr-h-16" />
              }
              title="Download"
              subtext="Get a PDF version of the receipt"
              onClick={() => {
                if (receipt?.receipt_url) {
                  window.open(receipt?.receipt_url, "_blank");
                }
              }}
            />
            <ReceiptActionItem
              icon={
                <WhatsAppBrandIcon className="dr-text-darwin-primary-primary dr-w-16 dr-h-16" />
              }
              title="Send on WhatsApp"
              subtext="Send from your own WhatsApp"
              onClick={sendViaOwnWhatsApp}
            />
          </div>
        </div>
        <div className="dr-flex-1">
          <PdfRenderer url={receipt?.receipt_url || ""} />
        </div>
      </div>
    </Modal>
  );
}

function ReceiptActionFooter() {
  const closeReceiptPopup = useReceiptStore(
    (state) => state.setCloseReceiptPopup
  );
  const selectedAppointment = useReceiptStore(
    (state) => state.selectedAppointment
  );

  const receipt = useReceiptStore((state) => state.receipt);

  const receiptId = useReceiptStore((state) => state.receiptId);
  return (
    <div className="dr-flex dr-justify-between dr-items-center dr-p-6">
      <div className="dr-flex dr-space-x-16">
        {receipt?.receipt_type === RECEIPT_TYPE.DUE_PAYMENT ||
        !!receipt?.payment_id ? null : (
          <SecondaryButton
            title="Edit"
            onClick={() => {
              if (receiptId) {
                editReceipt({
                  appointment: selectedAppointment,
                  receiptId: receiptId,
                });
              }
            }}
          />
        )}
        <SecondaryButton
          title="New Receipt"
          onClick={() => {
            if (selectedAppointment) {
              createNewReceipt({ appointment: selectedAppointment });
            }
          }}
        />
        <SecondaryButton
          title="Refund"
          onClick={() => {
            if (selectedAppointment) {
              createNewReceipt({ appointment: selectedAppointment });
            }
          }}
        />
      </div>
      <div>
        <PrimaryButton
          title="Done"
          onClick={() => {
            closeReceiptPopup();
            closeReceiptPopupEvent();
          }}
        />
      </div>
    </div>
  );
}
